import Link from '@/components/ui/Link';
import classnames from 'classnames';

import type { TextLinkBlock as TextLinkBlockProps } from '@/@types/content';

interface TextLinkProps extends TextLinkBlockProps {
  isUnpadded: boolean;
}

const TextLinkBlock: React.FC<TextLinkProps> = ({ link, isUnpadded }) => {
  const textlinkClasses = classnames('text-gray-dark', {
    'py-[10px]': !isUnpadded
  });
  return <Link propertyName="Link" {...link} variant="text-link-1" className={textlinkClasses} />;
};

export default TextLinkBlock;
